import { render, staticRenderFns } from "./BettingAction.vue?vue&type=template&id=563e97da&"
import script from "./BettingAction.vue?vue&type=script&lang=js&"
export * from "./BettingAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports